/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import Loader from '/client/src/components/Loader';
import NavbarTitleBackAction from './../components/topNavbar/backAction';
import PreloadPanelRow from './../components/panel/preloadPanelRow';
import GlobalError from '/client/src/pages/NotFound/GlobalError';
import RefundAllBanner from '/client/src/pages/Events/detail/refund/refundAllBanner';

import './styles/eventDetails.scss';
import { GET } from '../api';

type PropsType = {
  children?: React.Node,
  match: {
    params: {
      eventId?: number | string,
      viewTab?: string
    }
  },
  hideNavBar?: boolean
};

const tabs = [
  {
    link: 'stats',
    label: 'stats'
  },
  {
    link: 'manage',
    label: 'manage'
  },
  {
    link: 'customers',
    label: 'guests'
  },
  {
    link: 'edit',
    label: 'edit'
  },
  {
    link: 'design',
    label: 'design'
  }
];

class EventDetailContainer extends React.Component<PropsType> {
  props: PropsType;

  static getDerivedStateFromError = (error: any): {} => {
    console.error(error);

    return {
      hasError: true
    };
  };
  static contextType = DefaultContainerContext;

  state = {
    hasError: false,
    eventDetail: null,
    isSubMenuOpen: false
  };

  handleLoaded = (err: Error, response: {}) => {
    if (err) {
      console.log(err);
    }
    const result = _.get(response, 'data.result', {});
    const isRefundAllInProgress = _.get(result, 'refundall_in_progress', false);

    this.setState({
      eventDetail: {
        ...result,
        permission: result.permission || 'Write'
      }
    });

    // hide menu by default on /events/{id}
    if (window.location.pathname === 'manage') this.context.handleToggleLeftMenu(false);

    this.context.handleToggleHeaderBanner(isRefundAllInProgress, <RefundAllBanner />);
  };

  componentWillUnmount() {
    this.context.handleToggleLeftMenu(true);
    this.context.handleToggleHeaderBanner(false);
  }

  handleSetEventDetail = (eventDetail: {}) => {
    this.setState({ eventDetail });
  }

  handleUpdateData = async () => {
    try {
      const { result } = await GET(`/api/v1/1/events/${this.state.eventDetail.id}/detail`);

      this.setState({
        eventDetail: {
          ...result,
          permission: result.permission || 'Write'
        }
      });
    } catch (e) {
      console.log(e);
      location.reload();
    }
  }

  getBackActionPath = (): string => {
    const currentUrl = this.props.match.url;
    const param = 'manage';
    const index = currentUrl.indexOf(param) + param.length;

    if (currentUrl.includes(param) && currentUrl.length > index) {
      return currentUrl.slice(0, index);
    }

    return '/events';
  }

  toggleSubMenu = () => {
    this.setState((prevState: any): void => ({
        isSubMenuOpen: !prevState.isSubMenuOpen
    }));
  }

  render(): React.Element {
    const { children, match: { params: { eventId, viewTab } }, hideNavBar } = this.props;
    const { eventDetail, hasError, isSubMenuOpen } = this.state;
    const backActionPath = this.getBackActionPath();
    const isReadonlyPermission = _.get(eventDetail, 'permission', 'Write') === 'Read';

    return (
      <EventDetailContainerContext.Provider
        value={{
          eventDetail,
          handleSetEventDetail: this.handleSetEventDetail,
          handleUpdateData: this.handleUpdateData
        }}
      >
        { !hideNavBar &&
          <NavbarTitleBackAction path={backActionPath} />
        }

        <div className="sparxo-router-content">
          <div className="sparxo-page-container EventDetailContainer">
          { !hideNavBar &&
            <div className="navbar navbar-default navbar-submenu">
              <div className="navbar-header">
                <button
                  type="button"
                  className="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#sparxo-submenu-collapse-1"
                  aria-expanded="false"
                  onClick={() => this.toggleSubMenu()}
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                </button>

                {eventDetail ?
                  <span
                    className="navbar-brand"
                    id='EventDetailContainer-EventName'
                  // ref={this.wrapper}
                  >{eventDetail.name}</span> :
                  <PreloadPanelRow />
                }
              </div>
              { _.get(eventDetail, 'permission', '') &&
                <div className={`collapse navbar-collapse ${isSubMenuOpen ? 'in' : ''}`} id="sparxo-submenu-collapse-1">
                  <ul className="nav navbar-nav navbar-right">
                    {_.map(tabs, (tabI: {}, tabK: number): React.Element<'li'> => {
                      if (isReadonlyPermission && tabI.link === 'edit') return;
                      return (
                        <li
                          key={`EventDetailContainer-sparxo-submenu-${tabK}`}
                          className={viewTab === tabI.link ? 'active' : ''}
                        >
                          <Link to={`/events/${eventId}/${tabI.link}`}>{tabI.label}</Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              }
            </div>
            }
            {hasError ? <GlobalError /> :
              <Loader
                url={`/api/v1/1/events/${eventId}/detail`}
                onLoaded={this.handleLoaded}
              >
                {!!_.size(eventDetail) ? <>{children ? children : null}</> : null}
              </Loader>
            }
          </div>
        </div>
      </EventDetailContainerContext.Provider>
    );
  }
}

export default withRouter(EventDetailContainer);
